import { render } from "./Citizen.vue?vue&type=template&id=6651a7e1&ts=true"
import script from "./Citizen.vue?vue&type=script&lang=ts"
export * from "./Citizen.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../ss/AZ/ui/NibrsRepository/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__